// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Ported as-is; the `ui` Collapse restyles the expand arrow
import { Collapse } from 'antd';
import type { Topic } from 'models';
import { Trans } from 'react-i18next';
import { ArrowDownLineIcon, Flex } from 'ui';
import { Text } from 'ui/typography';

type P = {
  topics: Topic[];
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramTopics = ({ topics }: P) => (
  <Flex className="card-wrapper card-wrapper--topics">
    <Flex className="card-content--topics" vertical>
      <Text className="card-content__title">
        <Trans>Modules</Trans>
      </Text>
      <Collapse
        bordered={false}
        className="topics-list"
        expandIcon={() => <ArrowDownLineIcon />}
        items={topics.map((topic, index) => ({
          children: <p>{topic.description}</p>,
          className: 'topics-list__item',
          key: index,
          label: (
            <Flex className="topics-list__header">
              <span>{index + 1}</span>
              {topic.name}
            </Flex>
          ),
        }))}
      />
    </Flex>
  </Flex>
);

export default ProgramTopics;
